import React from 'react'

import * as StringFormatter from '../../global/formatters/string-formatter.js'
import { isInvestor } from '../../global/authentication/authentication-manager.js'

export default function SavedWatchList({ funds, priceAsOfDate }) {
  const formattedDate = priceAsOfDate
    ? StringFormatter.formatDateStandard(priceAsOfDate)
    : ''

  const renderNavChange = (change) => {
    if (change > 0) {
      return (
        <div className="u-flex u-flexJustifyEnd cti-colorUp">
          {change}{' '}
          <span className="Icon--material u-textSizeMsrp2 u-marginLeft1gu">
            &#xE5D8;
          </span>
        </div>
      )
    } else {
      return (
        <div className="u-flex u-flexJustifyEnd cti-colorDown">
          {change}{' '}
          <span className="Icon--material u-textSizeMsrp2 u-marginLeft1gu">
            &#xE5DB;
          </span>
        </div>
      )
    }
  }

  return (
    <div id="watch-list-saved">
      <p className="u-textSecondary u-textSizeMsrp1 u-marginTop4gu u-marginBottom1gu">
        <span className="u-textBold u-textSecondary u-textSizeMsrp2">
          Fund Data
        </span>{' '}
        as of {formattedDate}
      </p>
      <div className="Table-overflowWrapper u-paddingRight2gu">
        <table className="Table">
          <colgroup>
            <col />
            <col />
            <col />
          </colgroup>
          <thead className="Table-head">
            <tr className="Table-row">
              <th
                className="Table-header"
                style={{ height: 'auto' }}
                colSpan={!isInvestor() ? 3 : 2}
              >
                Fund Name Class
              </th>
              <th
                className="Table-header u-textRight"
                style={{ height: 'auto' }}
              >
                NAV $
              </th>
              <th
                className="Table-header u-textRight"
                style={{ height: 'auto' }}
              >
                NAV $ CHANGE
              </th>
            </tr>
          </thead>
          <tbody>
            {funds &&
              funds.map((fund) => {
                return (
                  <tr key={fund.fundName + fund.fundClass}>
                    <td
                      className="Table-cell u-padding2gu"
                      style={{ verticalAlign: 'middle' }}
                      colSpan={!isInvestor() ? 3 : 2}
                    >
                      <div className="u-textColorBrand u-textBold">
                        {fund.fundName} - {fund.fundClass}
                      </div>
                      <div className="u-textPrimary">{fund.symbol}</div>
                    </td>
                    <td
                      className="Table-cell u-padding2gu u-textRight u-textPrimary u-textColorBrand"
                      style={{ verticalAlign: 'middle' }}
                    >
                      {fund.navDollar}
                    </td>
                    <td
                      className="Table-cell u-padding2gu u-textRight u-textPrimary"
                      style={{ verticalAlign: 'middle' }}
                    >
                      {renderNavChange(fund.navDollarChange)}
                    </td>
                  </tr>
                )
              })}
          </tbody>
        </table>
      </div>
    </div>
  )
}
